const Plus = () => {
  return (
    <svg width={12 * 1.5} height={12 * 1.5} viewBox="0 0 12 12" fill="none">
      <path
        d="M5.99734 1.06562L5.94004 10.9916M1 6L10.9374 6.05723"
        stroke="black"
        strokeOpacity={0.9}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Plus;
